import { Link } from "react-router-dom";
import Image from "../../Images/Profile photo.png";
import Resume from "../../Images/Resume_template.pdf";
export default function Home() {
  return (
    <section className="home">
      <div className="hero">
        <div className="hero-copy">
          <p className="eyebrow">
            <span className="small-dot" /> SOFTWARE DEVELOPER · IIT KANPUR
          </p>
          <h1>
            Hi, I'm Rahul.
            <br />I build things
            <br />
            <span>for the web.</span>
          </h1>
          <p className="hero-description">
            I build responsive web applications and intelligent systems,
            combining frontend development with machine learning and computer
            vision.
          </p>
          <div className="actions">
            <Link className="button" to="/portfolio">
              Explore my work <span>↗</span>
            </Link>
            <a
              className="text-link"
              href={Resume}
              download="Rahul_Kumar_Resume.pdf"
            >
              Download resume ↓
            </a>
          </div>
          <div className="hero-note">
            <span>BIHAR, INDIA</span>
            <span>M.Tech student · Developer · Problem solver</span>
          </div>
        </div>
        <div className="portrait-area">
          <div className="portrait-frame">
            <img src={Image} alt="Rahul Kumar Chaudhary" />
          </div>
          <div className="portrait-caption">
            <span>Rahul Kumar Chaudhary</span>
            <span>Developer & problem solver</span>
          </div>
          <span className="portrait-spark" aria-hidden="true">
            ✳
          </span>
        </div>
      </div>
      <div className="focus-strip">
        <p>A LITTLE OF WHAT I DO</p>
        <span>Frontend development</span>
        <span>Full-stack applications</span>
        <span>Machine learning</span>
      </div>
      <section className="home-bottom">
        <div>
          <p className="eyebrow">A LITTLE ABOUT ME</p>
          <h2>
            Code with purpose.
            <br />
            Learn with curiosity.
          </h2>
        </div>
        <div>
          <p>
            After completing my B.Tech in Information Technology at IIEST
            Shibpur, I joined IIT Kanpur for an M.Tech in Space, Planetary &amp;
            Astronomical Sciences &amp; Engineering.
          </p>
          <Link className="text-link" to="/about">
            More about me ↗
          </Link>
        </div>
      </section>
    </section>
  );
}
